'use client';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { CatButton, CatIconSwap } from 'components/blocks-components';
import { useTranslations } from 'next-intl';

export const EquipmentChangeButton = () => {
  const t = useTranslations();
  const { selectEquipmentDrawer } = useMyEquipmentDrawer();
  const handleOpenDrawer = (drawer) => {
    drawer.openDrawer();
  };

  return (
    <CatButton
      variant="ghost"
      size="sm"
      data-testid="cat-button"
      onClick={() => handleOpenDrawer(selectEquipmentDrawer)}
      data-track-event="e_primaryCTA"
      data-track-attr-nltext="Change Equipment"
      data-track-attr-context="Homepage Menu"
    >
      <CatIconSwap slot="before" />
      {t('CHANGE')}
    </CatButton>
  );
};
